import React, { Component } from "react";
import { __, Alert, confirm } from "modules/theme";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import APIManager from "modules/common/apiManager";
// import CreatableSelect from 'react-select/creatable';
// import { ActionMeta, OnChangeValue } from 'react-select';
import Select from "react-select-plus";
import {
  ModalTrigger,
  Pagination,
  Button,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  Tip,
} from "modules/theme";
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper,
} from "modules/theme";
import { Textarea } from "../../../../theme";
import {
  ModalForm,
  ModalFormContainer,
} from "../../../../theme/theme1/common/styles/main";
import { ModalSmallIconButton } from "../styles";
import CommonManager from "../../../../../helpers/common";

export class EmailProviderAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.handleOnChange.bind(this);
    this.handleOnChangeCC.bind(this);

    this.mAPI = new APIManager();
    this.commonManager = new CommonManager();

    if (this.props.editData && this.props.editData._id) {
      this.state = {
        name: this.props.editData.name,
        host: this.props.editData.host,
        port: this.props.editData.port,
        from: this.props.editData.from,
        authPassword: this.props.editData.password,
        authUser: this.props.editData.user,
        secure: this.props.editData.secure,
        defaultBcc: this.props.editData.defaultBcc,
        defaultcc: this.props.editData.defaultcc,
        tlsHeader: this.props.editData.tlsHeader,
        value: this.getInitialValue(this.props.editData.defaultBcc),
        valueForCC: this.getInitialValue(this.props.editData.defaultcc),
        header: this.props.editData.headerList,
        headerList: this.convertToArray(this.props.editData.tlsHeader),
      };
    } else {
      this.state = {
        name: "",
        host: "",
        port: "5060",
        from: "",
        authPassword: "",
        authUser: "",
        secure: false,
        defaultBcc: [],
        defaultcc: [],
        value: null,
        valueForCC: null,
        correctIP: false,
        tlsHeader: { "": "" },
        header: {},
        headerList: [{ key: "", value: "" }],
      };
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      name: "",
      type: "",
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
    }
  }
  convertToObj(list) {
    let obj = {};
    list.map((el) => {
      obj[el.key] = el.value;
    });
    return obj;
  }
  saveData(e) {
    let _this = this;
    e.preventDefault();
    this.props.clearSearchField();
    if (this.state.port < 0 || this.state.port > 65536) {
      Alert.error("port is not valid");
      return false;
    }

    let ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    let domainFormat = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
    if (
      this.state.host.match(ipformat) ||
      this.state.host.match(domainFormat)
    ) {
    } else {
      Alert.error("You have entered invalid ip");
      return false;
    }

    let emailFormat = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    if (this.state.from.match(emailFormat)) {
    } else {
      Alert.error("You have entered invalid email");
      return false;
    }

    // if ((this.state.defaultcc.length===0 || this.state.defaultBcc.length===0)) return Alert.error('Please enter CC/BCC')
    let objForApi = this.convertToObj(this.state.headerList);
    let tData = {
      name: this.state.name.trim(),
      host: this.state.host,
      port: this.state.port,
      from: this.state.from,
      authPassword: this.state.authPassword,
      authUser: this.state.authUser,
      secure: this.state.secure,
      defaultBcc: this.state.defaultBcc,
      defaultcc: this.state.defaultcc,
      tlsHeader: objForApi,
      type: "text",
    };

    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `setting/email-provider/${this.props.editData._id}`,
        tData,
        (data) => {
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(data.message);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "private",
        { id: tData._id },
        "PUT"
      );
    } else {
      this.mAPI.sendPostAPI(
        "setting/email-provider",
        tData,
        (data) => {
          Alert.success(`${data.message}`);
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }
  getInitialValue(list) {
    let initialList = [];
    if (list && list.length) {
      list.map((e) => {
        initialList.push({
          value: e,
          label: e,
          className: "Select-create-option-placeholder",
        });
      });
    }
    return initialList;
  }
  temp = [];
  handleOnChange(value) {
    // const temp=[]
    let formatedDefaultBcc = [];
    // this.setState({ defaultBcc: value });
    this.setState({ value: value });
    value.map((e) => {
      formatedDefaultBcc.push(e.value);
    });
    this.setState({ defaultBcc: formatedDefaultBcc });
  }
  handleOnChangeCC(value) {
    let formatedDefaultCC = [];
    this.setState({ valueForCC: value });
    value.map((e) => {
      formatedDefaultCC.push(e.value);
    });
    this.setState({ defaultcc: formatedDefaultCC });
  }

  convertToArray(headerObj) {
    let headerArr = [];
    for (let key in headerObj) {
      headerArr.push({
        key: key,
        value: headerObj[key],
      });
    }
    return headerArr;
  }

  removeClick(i) {
    let headerList = [...this.state.headerList];
    if (headerList.length === 1) {
      Alert.error(`Atleast one header needed`);
    } else {
      headerList.splice(i, 1);
    }
    this.setState({ headerList });
  }

  addClick() {
    this.setState((prevState) => ({
      headerList: [...prevState.headerList, { key: "", value: "" }],
    }));
  }

  headerRow(el, i) {
    return (
      <div
        key={i}
        style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}
      >
        <FormWrapper style={{ width: "100%" }}>
          <FormColumn>
            <ControlLabel>Key</ControlLabel>
            <FormControl
              name="key"
              type="key"
              placeholder="Add Key"
              value={el.key}
              onChange={(e) => {
                if (el) {
                  if (e.target.value !== " ") {
                    el.key = e.target.value;
                  }
                }
                this.setState({ headerList: this.state.headerList });
              }}
              required={false}
              autoComplete="off"
            />
          </FormColumn>
          <FormColumn>
            <ControlLabel>Value</ControlLabel>
            <FormControl
              name="value"
              type="value"
              placeholder="Add Value"
              value={el.value}
              onChange={(e) => {
                if (el) {
                  el.value = e.target.value || "";
                }
                this.setState({ headerList: this.state.headerList });
              }}
              required={false}
              autoComplete="off"
            />
          </FormColumn>
        </FormWrapper>

        <ModalSmallIconButton className="ms-2">
          <Tip text={`${"Add"}`} key={`${"Add"}`}>
            <Button
              btnStyle="link"
              onClick={this.addClick.bind(this, i)}
              style={{
                verticalAlign: "middle",
                fontSize: "18px",
                padding: "9px",
              }}
              icon="plus-circle"
            />
          </Tip>
          <Tip text={`${"Remove"}`} key={`${"Remove"}`}>
            <Button
              btnStyle="link"
              onClick={this.removeClick.bind(this, i)}
              style={{
                verticalAlign: "middle",
                fontSize: "16px",
                padding: "9px",
              }}
              icon="minus-circle"
            />
          </Tip>
        </ModalSmallIconButton>
      </div>
    );
  }

  headerList() {
    let list = this.state.headerList.map((el, i) => {
      return this.headerRow(el, i);
    });
    return list;
  }

  getHeader() {
    let obj = this.state.tlsHeader;
    let keyValueArr = [];
    return (
      <React.Fragment>
        {Object.entries(obj).map((t, k) => {
          keyValueArr.push(t);
          return (
            <div>
              <FormGroup>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-between">
                    <ControlLabel required={true}>{`key`}</ControlLabel>
                    <FormControl
                      value={`${t[0]}`}
                      id="tlsHeader"
                      required={true}
                      onChange={(e) => {
                        if (e.target.value === " ") {
                          return false;
                        }
                        let agentName =
                          e.target.value && e.target.value.trim() == ""
                            ? ""
                            : e.target.value;
                        t[0] = e.target.value;
                        keyValueArr[k][0] += e.target.value;
                        this.setState({ tlsHeader: this.state.tlsHeader });
                      }}
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    <ControlLabel required={true}>{`value`}</ControlLabel>
                    <FormControl
                      value={`${t[1]}`}
                      id="tlsHeader"
                      required={true}
                      onChange={(e) => {
                        if (e.target.value === " ") {
                          return false;
                        }
                        let agentName =
                          e.target.value && e.target.value.trim() == ""
                            ? ""
                            : e.target.value;
                        // this.setState({ tlsHeader: agentName });
                      }}
                    />
                  </div>
                  <span
                    class="material-symbols-outlined"
                    onClick={() => {
                      let arr = [this.state.tlsHeader];
                      arr.push({ "": "" });
                      this.setState({
                        tlsHeader: { ...this.state.tlsHeader, "": "" },
                      });
                    }}
                  >
                    add_circle
                  </span>
                  <span class="material-symbols-outlined">maximize</span>
                </div>
              </FormGroup>
            </div>
          );
        })}
      </React.Fragment>
    );
  }

  render() {
    const { __ } = this.context;
    const { modalType } = this.props;
    const exceptThisSymbols = ["e", "E", "-", "."];
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)} autoComplete="off">
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("name", {
                placeholder: "Provider Name",
                defaultValue: "",
                autoFocus: true,
                required: true,
                id: "name",
                maxLength: 25,
                value: this.state.name,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  let agentName =
                    e.target.value && e.target.value.trim() == ""
                      ? ""
                      : e.target.value;
                  this.setState({ name: agentName });
                },
              })}
              <div className="d-flex justify-content-between">
                <div>
                  {this.renderFormGroup("host", {
                    placeholder: "Domain or IP address",
                    defaultValue: "",
                    required: true,
                    id: "host",
                    value: this.state.host,
                    onChange: (e) => {
                      let ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                      if (e.target.value === " ") {
                        return false;
                      }
                      let agentName =
                        e.target.value && e.target.value.trim() == ""
                          ? ""
                          : e.target.value;
                      this.setState({ host: agentName });
                    },
                    onBlur: (e) => {
                      let ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                      let domainFormat = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
                      if (
                        e.target.value.match(ipformat) ||
                        e.target.value.match(domainFormat)
                      ) {
                        return;
                      } else {
                        Alert.error("You have entered invalid ip");
                      }
                    },
                  })}
                </div>
                <div>
                  {this.renderFormGroup("port", {
                    placeholder: "Network port",
                    defaultValue: "",
                    required: true,
                    id: "port",
                    value: this.state.port,
                    type: "number",
                    onKeyDown: (e) => {
                      exceptThisSymbols.includes(e.key) && e.preventDefault();
                    },
                    // min: 0,
                    // max: 65536,
                    onInput: (e) => {
                      const inputValue = e.target.value;
                      if (!/^\d*$/.test(inputValue)) {
                        e.target.value = inputValue.replace(/[eE]/g, ''); // Remove non-numeric characters
                        Alert.error("Only numeric values are allowed");
                      }
                    },
                    onChange: (e) => {
                      // let portTest = /^(?:[1-9]|[1-9][0-9]{1,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
                      // if (
                      //   this.commonManager.isValidPort(e.target.value) ||
                      //   !e.target.value
                      // ) {
                      //   this.setState({ port: e.target.value });
                      // } else {
                      //   Alert.error(`port number must be between 0 to 65536`);
                      // }
                      let newValue = e.target.value.replace(/[eE]/g, ''); // Remove non-numeric characters
                      if (this.commonManager.isValidPort(newValue) || !newValue) {
                        this.setState({ port: newValue });
                      } else {
                        Alert.error('Port number must be between 0 to 65536');
                      }
                      // if (e.target.value === " ") {
                      //   return false;
                      // }
                      // if (e.target.value < 0 || e.target.value > 65536) {
                      //   // let agentName = e.target.value && e.target.value.trim() == "" ? "" : e.target.value;
                      //   // this.setState({ port: agentName });
                      //   Alert.error(`port number must be between 0 to 65536`);
                      // }
                      // let agentName =
                      //   e.target.value && e.target.value.trim() == ""
                      //     ? ""
                      //     : e.target.value;
                      // this.setState({ port: agentName });
                    },
                    // onKeyDown: (e) => {
                    //   ["e", "E", "+", "-"].includes(e.key) &&
                    //     e.preventDefault();
                    // },
                  })}
                </div>
              </div>
              {this.renderFormGroup("from", {
                defaultValue: "",
                placeholder: "From",
                required: true,
                id: "from",
                type: "email",
                value: this.state.from,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  let agentName =
                    e.target.value && e.target.value.trim() == ""
                      ? ""
                      : e.target.value;
                  this.setState({ from: agentName });
                },
                onBlur: (e) => {
                  let emailFormat = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
                  if (e.target.value.match(emailFormat)) {
                    return;
                  } else {
                    Alert.error("You have entered invalid email");
                  }
                },
              })}
              {this.renderFormGroup("auth User", {
                defaultValue: "",
                placeholder: "Auth User",
                required: true,
                id: "authUser",
                type: "email",
                value: this.state.authUser,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  let agentName =
                    e.target.value && e.target.value.trim() == ""
                      ? ""
                      : e.target.value;
                  this.setState({ authUser: agentName });
                },
                onBlur: (e) => {
                  let emailFormat = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
                  if (e.target.value.match(emailFormat)) {
                    let agentName =
                      e.target.value && e.target.value.trim() == ""
                        ? ""
                        : e.target.value;
                    this.setState({ authUser: agentName });
                  } else {
                    Alert.error("You have entered invalid email");
                  }
                },
              })}
              {this.renderFormGroup("auth Password", {
                defaultValue: "",
                placeholder: "Auth Password",
                required: true,
                type: "password",
                id: "authPassword",
                value: this.state.authPassword,
                type: "text",
                autocomplete: "off",
                style: { webkitTextSecurity: "disc" },
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  let agentName =
                    e.target.value && e.target.value.trim() == ""
                      ? ""
                      : e.target.value;
                  this.setState({ authPassword: agentName });
                },
              })}

              <FormGroup>
                <div className="d-flex">
                  <span style={{ marginRight: "10px" }}>
                    <FormControl
                      {...{
                        componentClass: "checkbox",
                        checked: this.state.secure,
                        onChange: (e) =>
                          this.setState({ secure: !this.state.secure }),
                        placeholder: "Network port",
                        defaultValue: "",
                        id: "secure",
                        value: this.state.secure,
                      }}
                    />
                  </span>
                  <ControlLabel>{"security"}</ControlLabel>
                </div>
              </FormGroup>

              <FormGroup>
                <ControlLabel>{"BCC"}</ControlLabel>
                <Select.Creatable
                  key={`AgentList`}
                  placeholder={"Choose Agents"}
                  value={this.state.value}
                  onChange={(value) => this.handleOnChange(value)}
                  onClose={() => {
                  }}
                  multi={true}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel>{"CC"}</ControlLabel>
                <Select.Creatable
                  key={`AgentList`}
                  placeholder={"Choose Agents"}
                  value={this.state.valueForCC}
                  onChange={(value) => this.handleOnChangeCC(value)}
                  onClose={() => {
                  }}
                  multi={true}
                />
              </FormGroup>

              <FormGroup>
                <ControlLabel
                  required={true}
                  style={{
                    marginRight: "10px",
                    marginBottom: "12px",
                    color: "#626262",
                    padding: "0px 8px 0px 8px",
                    background: "#ffffff",
                  }}
                >{`TLS Header`}</ControlLabel>

                {this.headerList()}
              </FormGroup>
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            btnSize="medium"
            type="greyModalBtn"
            modalBtnTitle="Cancel"
            OnClick={() => {
              this.props.closeModal();
            }}
          />
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            modalBtnTitle={
              this.props.editData && this.props.editData._id ? "Update" : "Add"
            }
          />
        </ModalFooter>
      </ModalForm>
    );
  }
}

EmailProviderAddEdit.propTypes = {
  group: PropTypes.array,
};

EmailProviderAddEdit.contextTypes = {
  __: PropTypes.func,
};

export default EmailProviderAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/EmailProvider/components/EmailProviderAddEdit.js